import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface InterventionFileState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: InterventionFileState = {
  data: [],
  isLoading: false,
  error: null,
};

const InterventionFileSlice = createSlice({
  name: 'InterventionFile',
  initialState,
  reducers: {
    setInterventionFiles: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setInterventionFileLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setInterventionFileError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setInterventionFiles, setInterventionFileLoading, setInterventionFileError } =
  InterventionFileSlice.actions;

export default InterventionFileSlice.reducer;
